import { PagedRequestDto } from './paged-request.model';
import { BillingStatus } from './payments.model';

export interface PaymentRequest extends PagedRequestDto {
  ContractorId: string;
  Status: BillingStatus;
  StartDate: string;
  EndDate: string;
  PaymentBatchId: string;
}

export interface PaymentSearchDto extends PagedRequestDto {
  contractorId?: string;
  corporateId?: string;
  facilityId?: string;
  facilityIds?: string[];
  status?: BillingStatus;
  startDate?: string;
  endDate?: string;
  paymentBatchId?: string;
}
